import { ArrowRight, Mail, MapPin, Phone } from "lucide-react";
import { CONTACT, FOOTER_COLUMNS } from "@/lib/data";
import { useQuote } from "@/context/QuoteContext";

export default function Footer() {
  const { openQuoteModal } = useQuote();

  return (
    <footer className="bg-medis-navy text-white pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/logo.jpg" alt="MEDIS Group LLP" className="h-20 w-20 object-contain" />
              <div>
                <div className="font-display font-bold text-lg tracking-tight">MEDIS Group LLP</div>
                <div className="text-[10.5px] uppercase tracking-[0.16em] text-white/60">Trusted Imaging Partner</div>
              </div>
            </div>
            <p className="mt-5 text-white/70 text-[14px] leading-relaxed">
              MEDIS Group LLP delivers advanced medical imaging solutions with a sales-first approach backed by
              technical support, spare parts, cryogenic expertise and long-term lifecycle assistance for hospitals and
              diagnostic centres across India.
            </p>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-3 gap-8">
            {FOOTER_COLUMNS.map((col) => (
              <div key={col.title}>
                <div className="text-[11px] uppercase tracking-[0.2em] text-white/50 font-semibold">{col.title}</div>
                <ul className="mt-5 space-y-3">
                  {col.items.map((item) =>
                    item.modal ? (
                      <li key={item.label}>
                        <button
                          onClick={() => openQuoteModal()}
                          className="inline-flex items-center gap-1.5 text-[14px] text-white/80 hover:text-medis-teal transition-colors"
                          data-testid={`footer-link-${item.label.toLowerCase().replace(/\s|&/g, "-")}`}
                        >
                          {item.label} <ArrowRight className="h-3 w-3" />
                        </button>
                      </li>
                    ) : (
                      <li key={item.label}>
                        <a
                          href={item.href}
                          target={item.external ? "_blank" : undefined}
                          rel={item.external ? "noopener noreferrer" : undefined}
                          className="inline-flex items-center gap-1.5 text-[14px] text-white/80 hover:text-medis-teal transition-colors"
                          data-testid={`footer-link-${item.label.toLowerCase().replace(/\s|&/g, "-")}`}
                        >
                          {item.label}
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col lg:flex-row items-start lg:items-center gap-3 sm:gap-6 text-[13px]">
          <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 text-white/80 hover:text-medis-teal transition-colors whitespace-nowrap" data-testid="footer-sales-email">
            <Mail className="h-4 w-4 shrink-0" /> {CONTACT.email}
          </a>
          <a href={`tel:+91${CONTACT.phoneInt}`} className="flex items-center gap-2 text-white/80 hover:text-medis-teal transition-colors whitespace-nowrap" data-testid="footer-phone">
            <Phone className="h-4 w-4 shrink-0" /> {CONTACT.phone}
          </a>
          <div className="flex items-start gap-2 text-white/70">
            <MapPin className="h-4 w-4 shrink-0 mt-0.5" />
            <span>{CONTACT.address}</span>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="text-[12.5px] text-white/60">© {new Date().getFullYear()} MEDIS Group LLP. All rights reserved.</div>
          <div className="text-[12px] text-white/50 flex items-center gap-1">
            Sales-first. Support-backed.
            <span className="text-medis-teal font-semibold">Pan-India imaging solutions.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
